import { IS_PRODUCTION } from '@/constants/env'

export default function sendErrorLog(error: Error) {
  if (IS_PRODUCTION) {
    // appsignal.sendError(error)
  } else {
    console.error(error)
  }
}
